document.addEventListener('DOMContentLoaded', function() {
    const switchItemFlat = document.querySelectorAll('.switch-container .switch'); 
    const productsLayout = document.querySelectorAll('.products-layout');
    
    switchItemFlat.forEach((switchItem, index) => {
        switchItem.addEventListener('click', () => {
            switchItemFlat.forEach(item => item.classList.remove('active'));
            productsLayout.forEach(product => product.classList.remove('active'));
    
            switchItem.classList.add('active');
            if (productsLayout[index]) {
                productsLayout[index].classList.add('active');
            }
        });
    });
});